<!-- 
  /** 
  * @author Mau de Pallares 
  * @company Erillam Healthcare 
  * @version 2.0 
  */ -->
<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="list"
      :items-per-page="itemsPerPage"
      no-data-text="Sin resultados disponibles"
      dense
      fixed-header
      hide-default-footer
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="get(item, 3)">
              <v-icon color="secondary" v-bind="attrs" v-on="on">
                mdi-pencil
              </v-icon>
            </v-btn>
          </template>
          <span>Editar id: {{ item.idTypeFinding }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="checkCancel(item)">
              <v-icon color="error" v-bind="attrs" v-on="on">
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
          <span>Eliminar id: {{ item.idTypeFinding }}</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogCancelation" persistent max-width="30%">
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "MamaFindingTable",
  props: {
    list: Array,
    get: Function,
    deleteItem: Function,
    itemsPerPage: Number,
  },
  data() {
    return {
      dialogCancelation: false,
      headers: [
        {
          text: "Id Hallazgo",
          value: "idTypeFinding",
          sortable: false,
          align: "center",
          width: "20%",
        },
        {
          text: "Nombre",
          value: "name",
          sortable: false,
          align: "center",
          width: "10%",
        },
        {
          text: "Tipo de hallazgo",
          value: "typeFindingKey",
          sortable: false,
          align: "center",
          width: "10%",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
          width: "15%",
        },
      ],
    };
  },
  methods: {
    checkCancel(item) {
      this.dialogCancelation = true;
      this.$swal({
        toast: true,
        title: "¿Estás seguro de eliminar este valor?",
        text: "",
        icon: "warning",
        confirmButtonText: "Confirmar",
        showCancelButton: true,
        cancelButtonText: "No",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.value) {
          this.dialogCancelation = false;
          this.deleteItem(item);
        } else {
          this.dialogCancelation = false;
        }
      });
    },
  },
};
</script>
